import * as fromAuth from "@features/auth/store/auth.reducer";
import * as fromEmployees from "@features/employees/store/employees.reducer";
import * as fromGroups from "@features/groups/store/groups.reducer";
import { ActionReducerMap } from "@ngrx/store";

export interface AppState {
  auth: fromAuth.AuthState;
  groups: fromGroups.GroupsState;
  employees: fromEmployees.EmployeesState;
}

export const APP_REDUCER: ActionReducerMap<AppState> = {
  auth: fromAuth.AUTH_REDUCER,
  groups: fromGroups.GROUPS_REDUCER,
  employees: fromEmployees.EMPLOYEES_REDUCER,
};
